'use client';

interface VideoPlayButtonProps {
  onClick: () => void;
  className?: string;
}

export function VideoPlayButton({ onClick, className = '' }: VideoPlayButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`group flex items-center justify-center w-24 h-24 md:w-32 md:h-32 rounded-full bg-black/40 backdrop-blur-sm hover:bg-black/50 transition-all hover:scale-105 ${className}`}
      aria-label="Play video"
    >
      <svg
        className="w-10 h-10 md:w-14 md:h-14 text-white group-hover:scale-110 transition-transform ml-1"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M8 5v14l11-7z" />
      </svg>
    </button>
  );
}

